import {AlertStyled} from "@/components/AlertStyled";
import {ContentContainer} from "@/components/ContentContainer";
import TextFieldStyled from "@/components/TextFieldStyled";
import {Button, Grid} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useRouter} from "next/router";
import {Spinner} from "@/components/Spinner";
import {confirmEmail, sendConfirmationEmail} from "@/lib/api";
import AppContext from "@/context/AppContext";

const Validate = () => {
    const {setSnackbar} = useContext(AppContext);
    const router = useRouter();
    const {confirmation: codeFromMail} = router.query;
    const [token, setToken] = useState(codeFromMail ?? "");
    const [email, setEmail] = useState('');
    const [formValid, setFormValid] = useState(false);
    const [tokenValid, setTokenValid] = useState(true);
    const [validating, setValidating] = useState(true);
    const [newCodeRequested, setNewCodeRequested] = useState(false);

    useEffect(() => {
        setFormValid(
            token?.length > 39
        );
    }, [token]);

    useEffect(() => {
        if (codeFromMail == null) {
            setValidating(false);
            setTokenValid(false);
            return;
        }

        validate(codeFromMail);
    }, [codeFromMail]);

    const validate = (code) => {
        setValidating(true);

        confirmEmail(code)
            .then((response) => {
                router.push("/register/complete");
            })
            .catch((error) => {
                setToken(codeFromMail);
                setTokenValid(false);
            })
            .finally(() => {
                setValidating(false);
            });
    };

    const handleTokenChanged = (event) => {
        const {name, value} = event.target;
        setToken(value);
    };

    const handleEmailChanged = (event) => {
        const {name, value} = event.target;
        setEmail(value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        validate(token);
    };

    const handleRequestCode = (event) => {
        event.preventDefault();

        sendConfirmationEmail(email).then(() => {
            setNewCodeRequested(true);
        })
            .catch(async (error) => {
                if (error.response.status === 400) {
                    if (error.response.data.message === "already.confirmed") {
                        setSnackbar({
                            type: "info",
                            content: "Die E-Mail Adresse wurde bereits bestätigt"
                        });
                    } else {
                        setSnackbar({
                            type: "error",
                            content: "Es ist ein Fehler aufgetreten, bitte prüfe die angegebene E-Mail Adresse."
                        });
                    }
                } else if (error.response.status === 500) {
                    setSnackbar({
                        type: "error",
                        content: "Es ist ein Fehler aufgetreten, bitte prüfe die angegebene E-Mail Adresse."
                    });
                } else {
                    console.debug(error.response);
                    setSnackbar({
                        type: "error",
                        content: "Es ist ein Fehler aufgetreten, bitte prüfe die angegebene E-Mail Adresse."
                    });
                }
            });
    };

    return (
        <ContentContainer headline="E-Mail bestätigen">
            <Grid container justifyContent="center">
                <Grid item xs={10}>
                    {validating && <Spinner/>}
                    {!validating &&
                        <Grid container spacing={3}>
                            {(!tokenValid && !newCodeRequested) &&
                                <Grid item xs={12}>
                                    <form onSubmit={handleRequestCode} name="request-code">
                                        <AlertStyled severity="error"
                                                     text="Abschlussvorgang leider nicht erfolgreich. Der Einmal-Code ist leider ungültig. Bitte fordere einen neuen Code an indem du deine E-Mail Adresse eingibst und unten auf den Button klickst"/>
                                        <Grid item xs={12} textAlign="center">
                                            <TextFieldStyled
                                                required={true}
                                                type="email"
                                                label="E-Mail Adresse"
                                                placeholder="name@example.com"
                                                name="email"
                                                onChange={handleEmailChanged}
                                            />
                                            <Button variant="contained" color="secondary" fullWidth type="submit">
                                                Neuen Code anfordern
                                            </Button>
                                        </Grid>
                                    </form>
                                </Grid>
                            }
                            {newCodeRequested &&
                                <Grid item xs={12}>
                                    <form onSubmit={handleSubmit} name="validate-code">
                                        <TextFieldStyled
                                            required={true}
                                            type="text"
                                            label="Gib hier den Token aus der Mail ein"
                                            placeholder="Uja9Q9Zb..."
                                            labelhint="40 Zeichen"
                                            name="token"
                                            onChange={handleTokenChanged}
                                        />
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            color="secondary"
                                            type="submit"
                                            disabled={!formValid}
                                        >
                                            Jetzt prüfen
                                        </Button>
                                    </form>
                                </Grid>
                            }
                        </Grid>
                    }
                </Grid>
            </Grid>
        </ContentContainer>
    );
};

export default Validate;
